var components
try {
  components = {
    uTransition: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-transition/u-transition" */ "@/uni_modules/uview-ui/components/u-transition/u-transition.vue"
      )
    },
    uIcon: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-icon/u-icon" */ "@/uni_modules/uview-ui/components/u-icon/u-icon.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var s0 = _vm.__get_style([
    {
      marginRight: _vm.closable ? "10px" : 0,
      marginTop: _vm.closable ? "10px" : 0,
    },
    _vm.style,
  ])
  var g0 = _vm.icon ? _vm.$u.test.image(_vm.icon) : null
  var s1 = _vm.icon && g0 ? _vm.__get_style([_vm.imgStyle]) : null
  var s2 = _vm.__get_style([_vm.textColor])
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        s0: s0,
        g0: g0,
        s1: s1,
        s2: s2,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }